// navigationHelper.js
let navigate;

export const setNavigate = (navFunction) => {
    navigate = navFunction;
};

export const redirectToSelectCompany = () => {
    if (navigate) {
        navigate('/select-company');
    }
};
